<template>
  <div>

    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="fetchData === undefined"
    >
      <h4 class="alert-heading">
        Error fetching organization data
      </h4>
      <div class="alert-body">
        No organization found with this id. Check
        <b-link
          class="alert-link"
          :to="{ name: 'organization-list'}"
        >
          Organization List
        </b-link>
        for other organizations.
      </div>
    </b-alert>

    <template v-if="fetchData">
      <!-- First Row -->
      <b-row>
        <b-col
          cols="12"
          xl="9"
          lg="8"
          md="7"
        >
          <org-view-info-card :org-data="fetchData" />
        </b-col>
        <b-col
          cols="12"
          md="5"
          xl="3"
          lg="4"
        >
          <org-plan-card  
            :org-data="fetchData" 
            @refetch-data="refetchData"
          />
        </b-col>
      </b-row>

      <user-list />
    </template>

  </div>
</template>

<script>
import store from '@/store'
import router from '@/router'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  BRow, BCol, BAlert, BLink,
} from 'bootstrap-vue'
import orgStoreModule from '../orgStoreModule'
import OrgViewInfoCard from './OrgViewInfoCard.vue'
import OrgPlanCard from './OrgPlanCard.vue'
import UserList from './list/UserList.vue'

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BLink,

    // Local Components
    OrgViewInfoCard,
    OrgPlanCard,
    UserList,
  },
  methods: {
    refetchData() {
      store.dispatch('app-org/fetchData', { id: router.currentRoute.params.id })
      .then(response => { this.fetchData = response.data.data })
      .catch(error => {
        if (error.response.status === 404) {
          this.fetchData = undefined
        }
      })
    }
  },
  setup() {
    const fetchData = ref(null)

    const ORG_APP_STORE_MODULE_NAME = 'app-org'

    // Register module
    if (!store.hasModule(ORG_APP_STORE_MODULE_NAME)) store.registerModule(ORG_APP_STORE_MODULE_NAME, orgStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(ORG_APP_STORE_MODULE_NAME)) store.unregisterModule(ORG_APP_STORE_MODULE_NAME)
    })

    store.dispatch('app-org/fetchData', { id: router.currentRoute.params.id })
      .then(response => { fetchData.value = response.data.data })
      .catch(error => {
        if (error.response.status === 404) {
          fetchData.value = undefined
        }
      })

    return {
      fetchData,
    }
  },
}
</script>

